module.exports = __webpack_public_path__ + "img/3.61e4efd0.png";